import styles from '../styles.module.scss';
import RollCompetitionContentHeader from '../Header';
import skeleton from './styles.module.scss';
import RollPointGameContentSlot from '../Slot';
import RollCompeititonContentTabs from '../Tabs';
import RollCompetitionContentRenderer from '../Renderer';

export default function RollCompetitionContentSkeleton() {
  return (
    <div
      className={styles.container}
      style={{
        // @ts-ignore
        '--frame': `url(${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/roll-competition/frame-roll.png)`,
        '--frame-bg': `url(${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/roll-competition/background-roll.png)`,
      }}
    >
      <div className={styles.container__content}>
        <RollCompetitionContentHeader isLoading />
        <div className={styles.container__content__card}>
          <div className={styles.container__content__row}>
            <div className={skeleton.label} />
            <div className={skeleton.label} />
          </div>
          <RollPointGameContentSlot isLoading />
        </div>
        <div className={styles.container__content__tabs}>
          <RollCompeititonContentTabs isLoading />
        </div>
        <RollCompetitionContentRenderer />
      </div>
    </div>
  );
}
